<span class="sm-rich-tooltip">
  <span
    #triggerText
    class="sm-rich-tooltip__trigger"
    [class.sm-rich-tooltip__trigger--search]="searchQuery.trim() && previewText.trim()"
    (mouseenter)="handleTriggerMouseEnter($event)"
    (mouseleave)="handleTriggerMouseLeave()"
    (pointerdown)="handleTriggerPointerDown()">
    <sm-search-highlight [text]="displayText" [query]="previewText.trim() ? searchQuery : ''" [context]="true"></sm-search-highlight>
  </span>

  @if (tooltipState && tooltipHtml) {
    <div
      #panel
      class="sm-rich-tooltip__panel app-scrollbar"
      [class.sm-rich-tooltip__panel--ready]="tooltipReady"
      role="tooltip"
      [style.left.px]="tooltipReady ? tooltipState.left : -9999"
      [style.top.px]="tooltipReady ? tooltipState.top : -9999"
      [style.width.px]="tooltipState.width"
      [style.maxHeight.px]="tooltipState.maxHeight"
      (mouseenter)="handleTooltipMouseEnter()"
      (mouseleave)="handleTooltipMouseLeave()">
      <div class="sm-rich-tooltip__content" [innerHTML]="tooltipHtml"></div>
    </div>
  }
</span>
